"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgo-a-mozzano": {
    "f8a26515": [{
      "hkey": "30532bf3",
      "slug": "gioviano-piano-di-gioviano",
      "name": "Gioviano-Piano di Gioviano",
      "primary": true,
      "skipSearch": false
    }],
    "gioviano": [{
      "hkey": "30532bf3",
      "slug": "gioviano-piano-di-gioviano",
      "name": "Gioviano-Piano di Gioviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b37a0e65": [{
      "hkey": "f9f1bcb7",
      "slug": "pieve-di-cerreto",
      "name": "Pieve di Cerreto",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "f9f1bcb7",
      "slug": "pieve-di-cerreto",
      "name": "Pieve di Cerreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;